import { connect } from "react-redux";
import { compose } from "redux";
import DialoguePageFront from "../components/dialogue-page-front";
import { getVariables } from "../utilities/route";
import { withData } from "../decorators/with-data";
import gql from "graphql-tag";
import { withTranslations } from "../decorators/with-translations";
import { setSubmitError } from "../actions/survey";
import { QUESTIONNAIRE_FRAGMENT } from "../graphql/fragments";
import { withImprovementProjectData } from './withImprovementProjectData'

export const query = gql`
  query DiscussionPage(
    $surveyId: UUID!
    $languageCode: String
  ) {
    questionnaire(languageCode: $languageCode) {
      ...QuestionnaireFragment
    }
    afterGameDialogueTopics(
      surveyId: $surveyId,
      languageCode: $languageCode
    ) {
      id
      title
      questionsCount
      active
      questions {
        id
        title
        answersCount
        active
        comments {
          id
          likesCount
          text
          createdAt
          respondentColor
          hasLikeByThisRespondent
          authorRespondentId
          isOwnedByThisRespondent
          replies {
            id
            text
            respondentColor
            createdAt
            hasLikeByThisRespondent
            authorRespondentId
            isOwnedByThisRespondent
          }
        }
        image
      }
      tips {
        text
      }
      image
    }
    afterGameDialogueTotalStatistics(
      surveyId: $surveyId,
      languageCode: $languageCode
    ) {
      activeTopicsCount
      answersCount
      likesCount
    }
  }
  ${QUESTIONNAIRE_FRAGMENT}
`;


const mapStateToProps = ({ survey: { submitError } }) => {
  return {
    submitError,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    onSubmitError: (error) => {
      dispatch(setSubmitError(error));
    },
  };
};

export default compose(
  withTranslations,
  withData(query, {
    options: (props) => {
      return {
        ...getVariables(props),
        fetchPolicy: "cache-and-network",
      };
    },
  }),
  connect(mapStateToProps, mapDispatchToProps),
  withImprovementProjectData,
)(DialoguePageFront);



// WEBPACK FOOTER //
// ./src/containers/dialogue-page.js